import styled from 'styled-components';
import FreeCancelIconSvg from '../assets/hotels/free-cancel.svg';

const FreeCancelIcon = styled(FreeCancelIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default FreeCancelIcon;
